import { render, staticRenderFns } from "./Printers.yaml?vue&type=template&id=0d9cc25d&component"
import script from "./Printers.yaml?vue&type=script&lang=ts&component"
export * from "./Printers.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports